/* JobLogic pilot gate. Until GA, the JobLogic integration is only listed
 * for allowlisted accounts — a comma-separated set of account ids in the
 * NEXT_PUBLIC_JOBLOGIC_BETA_ACCOUNT_IDS env var (account ids aren't secret,
 * so a NEXT_PUBLIC var is fine and lets the client-side Settings tab gate
 * without extra server plumbing). Unset → nobody sees it yet; to GA, drop
 * this gate from IntegrationsTab and set the tile unconditionally. */

export function isJoblogicBetaAccount(accountId: string | null | undefined): boolean {
  if (!accountId) return false;
  const raw = process.env.NEXT_PUBLIC_JOBLOGIC_BETA_ACCOUNT_IDS ?? '';
  return raw
    .split(',')
    .map(s => s.trim())
    .filter(Boolean)
    .includes(accountId);
}
